import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import DataPrivacyPolicy from "./index";

const dataPrivacyPolicyRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Data Privacy Policy",
		basePath: "data-privacy-policy",
		mainComponent: <DataPrivacyPolicy />,
	    layout: "/console",	   
	    subTitle:"Data Privacy Policy",
		level:5,
		moduleId: 0,
	})
]

export default dataPrivacyPolicyRoutes;